/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainEntitiesPlutusPaymentStatusFromJSON, FxIdDomainEntitiesPlutusPaymentStatusToJSON, } from './FxIdDomainEntitiesPlutusPaymentStatus';
/**
 * Check if a given object implements the FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponse interface.
 */
export function instanceOfFxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponse(value) {
    if (!('Status' in value) || value['Status'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponseFromJSON(json) {
    return FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponseFromJSONTyped(json, false);
}
export function FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Status': FxIdDomainEntitiesPlutusPaymentStatusFromJSON(json['Status']),
    };
}
export function FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponseToJSON(json) {
    return FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponseToJSONTyped(json, false);
}
export function FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Status': FxIdDomainEntitiesPlutusPaymentStatusToJSON(value['Status']),
    };
}
//# sourceMappingURL=FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponse.js.map